import EventDispatcher from "../../../../util/EventDispatcher";
import { isNull } from "../../../../util/TypeUtil";
import ContentFactory from "../../../content/ContentFactory";

/**
 * DialogContentPackage.js
 * 
 * Created on Oct 3, 2013, 10:30:31 AM
 *
 * @author Javier Quevedo-Fernandez for Ranj
 **/
export default class DialogContentPackage {
    constructor(languagePack, content, characterID) {
        this.languagePack = languagePack;
        this.content = content;
        this.characterID = characterID;
    }

    setPropertiesFromObject({characterID, content}) {
        this.characterID = characterID;
        if (isNull(content)) {
            this.content = null;
        } else {
            this.content = ContentFactory.getContentFromObject(content, this.languagePack);
            if (isNull(this.content)) {
                throw new Error(`Unknown content type in dialog file: ${content.type}`);
            }
        }
    }
}